import { useCallback } from 'react';
import { useOpenModal } from 'src/common/components/next-modal';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { publicLink } from 'src/common/const';

export const useOpenDownloadDesktopDialog = () => {
  const openModal = useOpenModal();
  const { t } = useAppTranslation();

  return useCallback(
    (lowVersion: boolean) => {
      openModal.warning({
        title: lowVersion ? t('space.hooks.currentVersionTooLow') : t('common.file_size_limit'),
        content: lowVersion
          ? t('space.hooks.downloadLatestVersion')
          : t('space.hooks.useDesktopClient'),
        cancelText: t('common.cancel'),
        confirmText: t('space.hooks.goDownload'),
        colorType: 'active',
        confirm: () => {
          window.open(publicLink.appDownload);
        },
      });
    },
    [openModal, t]
  );
};
